import { popperGenerator } from "./auth-service-tools1017.js";
import eventListeners from "./auth-service-tools1026.js";
import popperOffsets from "./auth-service-tools1027.js";
import computeStyles from "./auth-service-tools1028.js";
import applyStyles from "./auth-service-tools1029.js";
import offset from "./auth-service-tools1030.js";
import flip from "./auth-service-tools1031.js";
import preventOverflow from "./auth-service-tools1032.js";
import arrow from "./auth-service-tools1033.js";
import hide from "./auth-service-tools1034.js";
var defaultModifiers = [eventListeners, popperOffsets, computeStyles, applyStyles, offset, flip, preventOverflow, arrow, hide];
var createPopper = /* @__PURE__ */popperGenerator({
  defaultModifiers
});
export { applyStyles, arrow, computeStyles, createPopper, defaultModifiers, eventListeners, flip, hide, offset, popperGenerator, popperOffsets, preventOverflow };